/*
 * @Descripttion: 电商供应商订单详情页state
 * @Author: 曹博
 * @Date: 2023-11-27 16:25:58
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-27 16:44:02
 */
import {
  AcceptInfoItem,
  InvoiceInfoRes,
  OrderDteailRes,
} from '../../api/orderManage'
import { WaterMarkOption } from '../../components/previewModal'
import { ActionType, CustomAction } from '../../global'
import { InitialModalOptions, ModalOptions } from '../../tools/state'

export const orderdetailTabKeyList = [
  '商品明细',
  '发货明细',
  '退货明细',
  '取消明细',
] as const
export type orderdetailTabKey = (typeof orderdetailTabKeyList)[number]

export type RadioDict = {
  [x in orderdetailTabKey]: {
    key: string
    keyName: string
    value: string
    // numMap: string
  }
}

export const initialRadioDict: RadioDict = {
  商品明细: {
    key: 'productDetail',
    value: '商品明细',
    keyName: '商品明细',
  },
  发货明细: {
    key: 'deliveryDetail',
    value: '发货明细(0)',
    keyName: '发货明细',
  },
  退货明细: {
    key: 'returnDetail',
    value: '退货明细(0)',
    keyName: '退货明细',
  },
  取消明细: {
    key: 'cancelDetail',
    value: '取消明细(0)',
    keyName: '取消明细',
  },
}

interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: orderdetailTabKey // 当前选中tab的key值
  isTableLoading?: boolean
  detailInfo?: OrderDteailRes
  selectedRows: any[]
  productList: any[]
  progressValue: string
  loading: boolean
  uploadCertificateModalOption: ModalOptions
  currentEditCertificate?: AcceptInfoItem
  isPreviewModalVisible: boolean
  previewFileUrl: string
  invoiceInfo?: InvoiceInfoRes
  waterMarkOption?: WaterMarkOption
  detailListData: {
    cancelInfoList: any[]
    deliveryList: any[]
    returnInfoList: any[]
  }
  isOpenModal: boolean
  richText: any
  orderDescriptionFiles: any[]
}

export const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '商品明细',
  isTableLoading: false,
  detailInfo: undefined,
  selectedRows: [],
  productList: [],
  progressValue: '',
  loading: false,
  uploadCertificateModalOption: InitialModalOptions,
  currentEditCertificate: undefined,
  isPreviewModalVisible: false,
  previewFileUrl: '',
  invoiceInfo: undefined,
  detailListData: {
    deliveryList: [],
    returnInfoList: [],
    cancelInfoList: [],
  },
  isOpenModal: false,
  richText: '',
  orderDescriptionFiles: [],
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKeyAction':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setCurrentRadioDictAction':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDetailInfoAction':
      newstate.detailInfo = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setProductListAction':
      newstate.productList = action.payload
      return newstate
    case 'setProgressValueAction':
      newstate.progressValue = action.payload
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setUploadCertificateModalOptionAction':
      newstate.uploadCertificateModalOption = action.payload
      return newstate
    case 'setCurrentEditCertificateAction':
      newstate.currentEditCertificate = action.payload
      return newstate
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'setInvoiceInfoAction':
      newstate.invoiceInfo = action.payload
      return newstate
    case 'setWaterMarkOptionAction':
      newstate.waterMarkOption = action.payload
      return newstate
    case 'setDetailListDataAction':
      newstate.detailListData = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setIsOpenModalAction':
      newstate.isOpenModal = action.payload
      return newstate
    case 'setOrderDescriptionFilesAction':
      newstate.orderDescriptionFiles = action.payload
      return newstate
    case 'setRichTextAction':
      newstate.richText = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 上传凭证弹窗相关属性
 * @param val
 * @returns
 */
export const setCurrentEditCertificateAction = (
  val?: AcceptInfoItem,
): CustomAction<Action> => ({
  type: 'setCurrentEditCertificateAction',
  payload: val,
})

/**
 * 上传凭证弹窗相关属性
 * @param val
 * @returns
 */
export const setUploadCertificateModalOptionAction = (
  val: ModalOptions,
): CustomAction<Action> => ({
  type: 'setUploadCertificateModalOptionAction',
  payload: val,
})

/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
export const setCurrentRadioDictAction = (val: any): CustomAction<Action> => ({
  type: 'setCurrentRadioDictAction',
  payload: val,
})

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
export const setCheckedRadioKeyAction = (
  val: React.Key,
): CustomAction<Action> => ({
  type: 'setCheckedRadioKeyAction',
  payload: val,
})

/**
 * 设置详情页信息对象
 */
export const setDetailInfoAction = (val: any): CustomAction<Action> => ({
  type: 'setDetailInfoAction',
  payload: val,
})

/**
 * 设置选中的行的信息列表
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

/**
 * 设置商品明细数组
 * @param val
 * @returns
 */
export const setProductListAction = (val: any): CustomAction<Action> => ({
  type: 'setProductListAction',
  payload: val,
})

/**
 * 设置商品明细进度筛选条件的值
 * @param val
 * @returns
 */
export const setProgressValueAction = (val: any): CustomAction<Action> => ({
  type: 'setProgressValueAction',
  payload: val,
})

/**
 * 设置加载状态
 * @param val
 * @returns
 */
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 预览弹窗
export const setIsPreviewModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

// 预览文件url
export const setPreviewFileUrlAction = (val: string): CustomAction<Action> => ({
  type: 'setPreviewFileUrlAction',
  payload: val,
})

export const setInvoiceInfoAction = (
  val?: InvoiceInfoRes,
): CustomAction<Action> => ({
  type: 'setInvoiceInfoAction',
  payload: val,
})

export const setWaterMarkOptionAction = (
  val?: WaterMarkOption,
): CustomAction<Action> => ({
  type: 'setWaterMarkOptionAction',
  payload: val,
})

// 明细列表数据
export const setDetailListDataAction = (val: any): CustomAction<Action> => ({
  type: 'setDetailListDataAction',
  payload: val,
})

// 明细列表loading
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

export const setIsOpenModalAction = (val: boolean): CustomAction<Action> => ({
  type: 'setIsOpenModalAction',
  payload: val,
})

export const setRichTextAction = (val: any): CustomAction<Action> => ({
  type: 'setRichTextAction',
  payload: val,
})

export const setOrderDescriptionFilesAction = (
  val: any,
): CustomAction<Action> => ({
  type: 'setOrderDescriptionFilesAction',
  payload: val,
})
/*
 * @Descripttion: 电商供应商订单详情页state
 * @Author: 曹博
 * @Date: 2023-11-27 16:25:58
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-27 16:44:02
 */
import {
  AcceptInfoItem,
  InvoiceInfoRes,
  OrderDteailRes,
} from '../../api/orderManage'
import { WaterMarkOption } from '../../components/previewModal'
import { ActionType, CustomAction } from '../../global'
import { InitialModalOptions, ModalOptions } from '../../tools/state'

export const orderdetailTabKeyList = [
  '商品明细',
  '发货明细',
  '退货明细',
  '取消明细',
] as const
export type orderdetailTabKey = (typeof orderdetailTabKeyList)[number]

export type RadioDict = {
  [x in orderdetailTabKey]: {
    key: string
    keyName: string
    value: string
    // numMap: string
  }
}

export const initialRadioDict: RadioDict = {
  商品明细: {
    key: 'productDetail',
    value: '商品明细',
    keyName: '商品明细',
  },
  发货明细: {
    key: 'deliveryDetail',
    value: '发货明细(0)',
    keyName: '发货明细',
  },
  退货明细: {
    key: 'returnDetail',
    value: '退货明细(0)',
    keyName: '退货明细',
  },
  取消明细: {
    key: 'cancelDetail',
    value: '取消明细(0)',
    keyName: '取消明细',
  },
}

interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: orderdetailTabKey // 当前选中tab的key值
  isTableLoading?: boolean
  detailInfo?: OrderDteailRes
  selectedRows: any[]
  productList: any[]
  progressValue: string
  loading: boolean
  uploadCertificateModalOption: ModalOptions
  currentEditCertificate?: AcceptInfoItem
  isPreviewModalVisible: boolean
  previewFileUrl: string
  invoiceInfo?: InvoiceInfoRes
  waterMarkOption?: WaterMarkOption
  detailListData: {
    cancelInfoList: any[]
    deliveryList: any[]
    returnInfoList: any[]
  }
  isOpenModal: boolean
  richText: any
  orderDescriptionFiles: any[]
}

export const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '商品明细',
  isTableLoading: false,
  detailInfo: undefined,
  selectedRows: [],
  productList: [],
  progressValue: '',
  loading: false,
  uploadCertificateModalOption: InitialModalOptions,
  currentEditCertificate: undefined,
  isPreviewModalVisible: false,
  previewFileUrl: '',
  invoiceInfo: undefined,
  detailListData: {
    deliveryList: [],
    returnInfoList: [],
    cancelInfoList: [],
  },
  isOpenModal: false,
  richText: '',
  orderDescriptionFiles: [],
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKeyAction':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setCurrentRadioDictAction':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDetailInfoAction':
      newstate.detailInfo = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setProductListAction':
      newstate.productList = action.payload
      return newstate
    case 'setProgressValueAction':
      newstate.progressValue = action.payload
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setUploadCertificateModalOptionAction':
      newstate.uploadCertificateModalOption = action.payload
      return newstate
    case 'setCurrentEditCertificateAction':
      newstate.currentEditCertificate = action.payload
      return newstate
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'setInvoiceInfoAction':
      newstate.invoiceInfo = action.payload
      return newstate
    case 'setWaterMarkOptionAction':
      newstate.waterMarkOption = action.payload
      return newstate
    case 'setDetailListDataAction':
      newstate.detailListData = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setIsOpenModalAction':
      newstate.isOpenModal = action.payload
      return newstate
    case 'setOrderDescriptionFilesAction':
      newstate.orderDescriptionFiles = action.payload
      return newstate
    case 'setRichTextAction':
      newstate.richText = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 上传凭证弹窗相关属性
 * @param val
 * @returns
 */
export const setCurrentEditCertificateAction = (
  val?: AcceptInfoItem,
): CustomAction<Action> => ({
  type: 'setCurrentEditCertificateAction',
  payload: val,
})

/**
 * 上传凭证弹窗相关属性
 * @param val
 * @returns
 */
export const setUploadCertificateModalOptionAction = (
  val: ModalOptions,
): CustomAction<Action> => ({
  type: 'setUploadCertificateModalOptionAction',
  payload: val,
})

/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
export const setCurrentRadioDictAction = (val: any): CustomAction<Action> => ({
  type: 'setCurrentRadioDictAction',
  payload: val,
})

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
export const setCheckedRadioKeyAction = (
  val: React.Key,
): CustomAction<Action> => ({
  type: 'setCheckedRadioKeyAction',
  payload: val,
})

/**
 * 设置详情页信息对象
 */
export const setDetailInfoAction = (val: any): CustomAction<Action> => ({
  type: 'setDetailInfoAction',
  payload: val,
})

/**
 * 设置选中的行的信息列表
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

/**
 * 设置商品明细数组
 * @param val
 * @returns
 */
export const setProductListAction = (val: any): CustomAction<Action> => ({
  type: 'setProductListAction',
  payload: val,
})

/**
 * 设置商品明细进度筛选条件的值
 * @param val
 * @returns
 */
export const setProgressValueAction = (val: any): CustomAction<Action> => ({
  type: 'setProgressValueAction',
  payload: val,
})

/**
 * 设置加载状态
 * @param val
 * @returns
 */
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 预览弹窗
export const setIsPreviewModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

// 预览文件url
export const setPreviewFileUrlAction = (val: string): CustomAction<Action> => ({
  type: 'setPreviewFileUrlAction',
  payload: val,
})

export const setInvoiceInfoAction = (
  val?: InvoiceInfoRes,
): CustomAction<Action> => ({
  type: 'setInvoiceInfoAction',
  payload: val,
})

export const setWaterMarkOptionAction = (
  val?: WaterMarkOption,
): CustomAction<Action> => ({
  type: 'setWaterMarkOptionAction',
  payload: val,
})

// 明细列表数据
export const setDetailListDataAction = (val: any): CustomAction<Action> => ({
  type: 'setDetailListDataAction',
  payload: val,
})

// 明细列表loading
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

export const setIsOpenModalAction = (val: boolean): CustomAction<Action> => ({
  type: 'setIsOpenModalAction',
  payload: val,
})

export const setRichTextAction = (val: any): CustomAction<Action> => ({
  type: 'setRichTextAction',
  payload: val,
})

export const setOrderDescriptionFilesAction = (
  val: any,
): CustomAction<Action> => ({
  type: 'setOrderDescriptionFilesAction',
  payload: val,
})
